import { render, staticRenderFns } from "./importantDates.vue?vue&type=template&id=20d29bbf&"
import script from "./importantDates.vue?vue&type=script&lang=js&"
export * from "./importantDates.vue?vue&type=script&lang=js&"
import style0 from "./importantDates.vue?vue&type=style&index=0&id=20d29bbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports